import { UserManager, User } from 'oidc-client';
import axios from 'axios';
import { FormValues, StateQueryResp } from './questions';

export const createUserManager = async (): Promise<UserManager> => {
  const config = await axios.get('/api/oidcconfig');
  return new UserManager({
    authority: config.data['authority'],
    client_id: config.data['client_id'],
    redirect_uri: config.data['redirect_uri'],
    post_logout_redirect_uri: config.data['redirect_uri'],
    response_type: 'code',
    scope: 'openid email profile groups',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    accessTokenExpiringNotificationTime: 30,
  });
};

export const checkSigninRedirect = async (
  userMgr: UserManager,
  setLoginState: (inProgress: boolean) => void,
  setInitialQuery: (a: StateQueryResp) => void,
) => {
  if (window.location.search) {
    const params = new URLSearchParams(window.location.search);
    if (params.has('state') && params.has('code')) {
      setLoginState(true);

      const user = await userMgr.signinRedirectCallback();
      window.history.replaceState({}, '', '/');

      const stateResp = await axios.get('/api/state', { headers: authHeaders(user) });

      const answers = stateResp.data.answers.map((ans: { data: FormValues; timestamp: string; profiles: string }) => {
        return { values: ans.data, timestamp: new Date(ans.timestamp), profiles: ans.profiles };
      });
      setInitialQuery({
        answers,
        formIsActive: stateResp.data.formIsActive,
        permissionToAnswer: stateResp.data.permissionToAnswer,
      });

      setLoginState(false);
    }
  }
};

export const userIsAdmin = (user: User): boolean => {
  const groups = user.profile['groups'] as string[] | undefined;
  return groups !== undefined && groups.some((v) => v.startsWith('cn=ews-yop-app-taitokartta-admin,'));
};

export const checkAnswerPermission = async (user: User): Promise<boolean> => {
  const permissionResp = await axios.get('/api/permission/answer', { headers: authHeaders(user) });
  return permissionResp.data as boolean;
};

export const authHeaders = (user: User): Record<string, string> => {
  return { authorization: `Bearer ${user.access_token}` };
};
